import React, { useState, useEffect } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Box, Grid, Typography, Card, Button, IconButton, Chip, Skeleton, Avatar, Paper, Rating } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogTitle, Checkbox, FormControlLabel } from '@mui/material';
import { Facebook, Instagram, X, LinkedIn, YouTube } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Header1 from '../Header/Header1';
import Footer from '../Footer/Footer';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ReportIcon from '@mui/icons-material/Report';
import ShareButton from "../Share/ShareButton";
import Footer2 from '../Footer/Footer2';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import RequestRecommendations from '../Recommendations/RequestRecommendations';
import avatar from './default-avatar.png'
import ShareIcon from '@mui/icons-material/Share';
import FlagIcon from '@mui/icons-material/Flag';
import { styled } from '@mui/system';
import GenerateOTPButtonRequest from '../OTP/GenerateOTPButtonRequest';
import FeedbackFormAcceptedRequests from '../Feedback/FeedbackFormAcceptedRequests';
import GoogleMeetLogo from '../Post/GoogleMeetImage.png';
import ZoomMeetLogo from '../Post/ZoomMeetImage.png';
import TeamsMeetLogo from '../Post/TeamsMeetImage.png';
import YouTubeEmbed from '../UserProfile/YouTubeEmbed';
import CancelSessionAcceptedRequestsButton from '../Cancellations/CancelSessionAcceptedRequestsButton';
import ViewsLikesAnalyticsRequest from './ViewsLikesAnalyticsRequest';
import MeetingGuidelines from '../Guidelines/MeetingGuidelines';



const API_URL = process.env.REACT_APP_API_URL;


const AcceptedRequestTabDetails = ({ onLogout }) => {

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top when this page is loaded
  }, []);


  const { id, userId } = useParams();
  const navigate = useNavigate();
  const [course, setCourse] = useState(null);
  const [action, setAction] = useState(null);
  const location = useLocation();
  const [bookingCreated, setBookingCreated] = useState(false)
  const paymentStatus = location.state?.paymentStatus || 'unknown';  // Default to 'unknown' if not provided
  const [status, setStatus] = useState(null);
  const [meetingLink, setMeetingLink] = useState('');
  const [platform, setPlatform] = useState('');

  const [openDialog, setOpenDialog] = useState(false); // To control the dialog's visibility
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    const fetchBookingStatus = async () => {
      try {
        const response = await axios.get(`${API_URL}/get_booking_status/`, {
          params: { request_id: id, user_id: userId },
        });

        if (response.status === 200) {
          setStatus(response.data.status);
          if (response.data.status === 'confirmed') {
            setMeetingLink(response.data.meeting_link);
            setPlatform(response.data.platform);
          }
        }
      } catch (error) {
        console.error("Error fetching booking status:", error);
      }
    };

    if (id && userId) {
      fetchBookingStatus();
    }
  }, [id, userId]);

  const getLogo = (platform) => {
    switch (platform) {
      case 'googleMeet':
        return GoogleMeetLogo;
      case 'zoom':
        return ZoomMeetLogo;
      case 'microsoftTeams':
        return TeamsMeetLogo;
      default:
        return null; // Optionally, you can return a default image or a placeholder here
    }
  };


  const getPlatformName = (platform) => {
    switch (platform) {
      case 'googleMeet':
        return 'Google Meet';
      case 'zoom':
        return 'Zoom';
      case 'microsoftTeams':
        return 'Microsoft Teams';
      default:
        return null;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_URL}/get_requested_data/?request_id=${id}`);
        setCourse(response.data[0]);

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [id, userId]);  // Depend on 'id' and 'userId' to ensure the data and view count is fetched only once


  useEffect(() => {
    const getUserPostInteraction = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/get_user_post_interaction/`,
          {
            params: {
              user_id: userId,
              post_id: id,
            },
          }
        );
        setAction(response.data.action); // Set the action (like, dislike, or null)
      } catch (error) {
        setAction(null);
        console.error("Error fetching user post interaction:", error);
      }
    };

    getUserPostInteraction();
  }, [userId, id]);

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };





  if (!course) {
    return <Typography variant="h6" sx={{ textAlign: "center", padding: "2rem" }}>Loading...</Typography>;
  }

  const formatStartTime = (time) => {
    const [hours, minutes] = time.split(':');
    const dateObj = new Date();
    dateObj.setHours(hours);
    dateObj.setMinutes(minutes);

    const formatter = new Intl.DateTimeFormat('en-US', {
      hour: '2-digit', minute: '2-digit', hour12: true
    });

    return formatter.format(dateObj); // returns time in AM/PM format
  }

  const formatDuration = (durationInMinutes) => {
    const hours = Math.floor(durationInMinutes / 60);
    const minutes = durationInMinutes % 60;

    if (hours > 0) {
      return `${hours} hour${hours > 1 ? 's' : ''} ${minutes} minute${minutes !== 1 ? 's' : ''}`;
    }

    return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
  };

  const formatExperience = (experience) => {
    if (experience) {
      let minutes = experience.split(':')[0];  // Extract the minute value before ":"
      return `${minutes} min`;
    } else {
      return "New user";  // If no experience, return "New user"
    }
  }

  const handleJoinClick = () => {
    setOpenDialog(true); // Open the dialog
  };



  const handleConfirmAndJoin = () => {
    if (isChecked) {
      window.open(course.meeting_link, '_blank'); // Open in a new tab
      setOpenDialog(false); // Close the dialog
    } else {
      alert('Please confirm that you understand the instructions.');
    }
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked); // Update checkbox state
  };


  const {
    topic_name, section_name, subsection_name, description, language, date, start_time,
    duration, name, surname, profile_picture,
    about, rating, experience, id: cardId, price, user_id, meeting_link,
    facebook, instagram, x, linkedin, youtube, likes, dislikes, specialized_fields, roles, post_rating, comments, meeting_platform,
  } = course;

  const durationFormatted = formatDuration(duration)
  const teacherRating = rating || "Not rated yet";
  const formattedStartTime = formatStartTime(start_time);
  const formatedExperience = formatExperience(experience)



  const handleShareClick = () => {
  };

  const handleRedirect = () => {
    navigate('/meeting-guidelines');  // Redirect to meeting guidelines page
  };




  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };


  return (
    <div>
      <Header1 userId={userId} onLogout={onLogout} />
      <Typography
        variant="h3"
        component="h1"
        align="center"
        fontSize={{ xs: '2rem', sm: '2.5rem', md: '3rem' }}
        sx={{
          backgroundImage: 'linear-gradient(45deg, #00bfff, #ff00ff)',
          mt: 10,
          letterSpacing: 10,
          WebkitBackgroundClip: 'text',  // This makes the gradient clip to the text
          color: 'transparent',  // Makes the text itself transparent to show the gradient
        }}
        gutterBottom
      >
        My Accepted Session View
      </Typography>
      <Box sx={{
        backgroundColor: "#000000", minHeight: "100vh", marginTop: "50px", marginBottom: "100px", px: { xs: 1, sm: 3, md: 5 }, // Responsive horizontal padding
        overflowX: "hidden",         // 💥 Prevent horizontal scroll
        width: "100%",
      }}>
        <Grid
          container
          spacing={3}
          justifyContent="center"
          sx={{
            backgroundColor: "#000000",
            width: "100%",
            margin: 0,
            padding: 0,
            overflowX: "hidden", // 💥 Just in case something leaks here
          }}
        >

          <Grid container justifyContent="center">
            <Box sx={{
              padding: { xs: "1.5rem", sm: "2rem", md: "3rem", lg: "4rem" },// Responsive padding
              backgroundColor: "#2222", // Darker background for modern look
              color: "#fff",
              borderRadius: "16px",
              height: "100%",
              boxSizing: "border-box",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
              "&:hover": {
                transform: "translateY(-5px)",
                boxShadow: "0 8px 20px rgba(0, 0, 0, 0.3)",
              },
            }}>

              <Box sx={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: "3rem" }}>
                <Avatar sx={{
                  width: 150,
                  height: 150,
                  // mr: 2,
                }} src={`${API_URL}${profile_picture}` || '/default-avatar.png'} alt={name || 'User'} />


                <Box sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  mt: 2, // Margin top for some space between the image and the icons
                }}>


                </Box>
              </Box>


              <Box sx={{ textAlign: 'center', marginTop: '1rem', padding: '1rem', width: '100%' }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    color: "#fff",
                    letterSpacing: 5,
                    fontFamily: "'Helvetica', sans-serif",
                    "&:hover": { color: '#1E90FF' },
                    fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.8rem' },  // Responsive font size
                  }}
                >
                  {name || "name"} {surname || "surname"}
                </Typography>




              </Box>

              <Typography
                variant="h6"
                sx={{
                  fontWeight: 500,
                  marginBottom: "1.5rem",
                  color: "#fff",
                  letterSpacing: 1,
                  textAlign: "center",
                  fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                  fontSize: {
                    xs: '1rem',   // small phones
                    sm: '1.2rem', // tablets
                    md: '1.4rem', // small desktops
                    lg: '1.55rem' // large desktops
                  },
                  lineHeight: 1.6,
                  "&:hover": {
                    color: '#1E90FF',
                  },
                }}
              >
                "{description}"
              </Typography>

              <Grid container spacing={2} justifyContent="center" alignItems="center">
                <Grid item xs={12} sm={8} md={6}>
                  <Box
                    sx={{
                      padding: '2rem',
                      borderRadius: '12px',
                      backgroundColor: '#333333', // Dark background for contrast
                      color: '#ffffff', // Light text for readability on dark background
                      boxShadow: 3,
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        textAlign: 'center',
                        marginBottom: '1.5rem',
                        fontWeight: 'bold',
                        color: '#ffffff',
                        letterSpacing: 4,
                      }}
                    >
                      Booking Status
                    </Typography>

                    {status === 'confirmed' ? (
                      <>
                        <Typography
                          variant="body1"
                          sx={{
                            textAlign: 'center',
                            marginBottom: '1rem',
                            fontWeight: '500',
                            letterSpacing: 3,
                          }}
                        >
                          Status: <strong>Confirmed</strong>
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            textAlign: 'center',
                            color: '#e0e0e0',
                            letterSpacing: 3,
                            marginBottom: '1.5rem',
                          }}
                        >
                          Your booking has been confirmed. You can proceed with the next steps.
                        </Typography>
                      </>
                    ) : status === 'pending' ? (
                      <>
                        <Typography
                          variant="body1"
                          sx={{
                            textAlign: 'center',
                            marginBottom: '1rem',
                            fontWeight: '500',
                            letterSpacing: 3,
                          }}
                        >
                          Status: <strong>Pending</strong>
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            textAlign: 'center',
                            color: '#e0e0e0',
                            letterSpacing: 3,
                            marginBottom: '1.5rem',
                          }}
                        >
                          Your booking is pending approval. Please check back later.
                        </Typography>
                      </>
                    ) : status === 'rejected' ? (
                      <>
                        <Typography
                          variant="body1"
                          sx={{
                            textAlign: 'center',
                            letterSpacing: 3,
                            marginBottom: '1rem',
                            fontWeight: '500',
                          }}
                        >
                          Status: <strong>Rejected</strong>
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            textAlign: 'center',
                            color: '#e0e0e0',
                            letterSpacing: 3,
                            marginBottom: '1.5rem',
                          }}
                        >
                          Unfortunately, your booking has been rejected. Please contact support for more details.
                        </Typography>
                      </>
                    ) : status === 'cancelled' ? (
                      <>
                        <Typography
                          variant="body1"
                          sx={{
                            textAlign: 'center',
                            letterSpacing: 3,
                            marginBottom: '1rem',
                            fontWeight: '500',
                          }}
                        >
                          Status: <strong>Cancelled</strong>
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            textAlign: 'center',
                            color: '#e0e0e0',
                            letterSpacing: 3,
                            marginBottom: '1.5rem',
                          }}
                        >
                          Your booking has been cancelled. If this was an error, please reach out to support.
                        </Typography>
                      </>
                    ) : (
                      <Typography
                        variant="body1"
                        sx={{
                          textAlign: 'center',
                          marginBottom: '1rem',
                          color: '#e0e0e0',
                          letterSpacing: 3,
                        }}
                      >
                        Unable to fetch status. Please try again later.
                      </Typography>
                    )}

                    <Typography
                      variant="body2"
                      sx={{
                        textAlign: 'center',
                        color: '#a0a0a0',
                        marginTop: '2rem',
                        fontStyle: 'italic',
                        letterSpacing: 3,
                      }}
                    >
                      If you have any questions, feel free to contact our support team.
                    </Typography>
                  </Box>
                </Grid>
              </Grid>

              <Grid container spacing={3} justifyContent="center" sx={{ mt: 5 }}>

                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    color: "#fff",
                    background: "linear-gradient(45deg, #333333, #555555)",

                    borderRadius: "8px",
                    padding: "6px 12px",
                    mr: 1,
                    mt: 1,
                    letterSpacing: 2,
                    textTransform: "uppercase",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
                    display: "inline-block",
                    fontSize: "0.875rem", // Smaller size for compactness
                    letterSpacing: "0.8px",
                    transition: "transform 0.3s ease-in-out, background 0.3s ease-in-out",
                    "&:hover": {
                      background: "linear-gradient(45deg, #6e7dff, #6b89ff)",
                      transform: "scale(1.05)",
                    },
                    "@media (max-width: 600px)": {
                      fontSize: "0.75rem", // Make text smaller on mobile
                      padding: "4px 10px", // Adjust padding for smaller screens
                    },
                  }}
                >
                  Language: {language || "N/A"}
                </Typography>


                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    color: "#fff",
                    background: "linear-gradient(45deg, #333333, #555555)",
                    borderRadius: "8px",
                    padding: "6px 12px",
                    textTransform: "uppercase",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
                    display: "inline-block",
                    mr: 1,
                    mt: 1,
                    letterSpacing: 2,
                    fontSize: "0.875rem", // Smaller size for compactness
                    letterSpacing: "0.8px",
                    transition: "transform 0.3s ease-in-out, background 0.3s ease-in-out",
                    "&:hover": {
                      background: "linear-gradient(45deg, #6e7dff, #6b89ff)",
                      transform: "scale(1.05)",
                    },
                    "@media (max-width: 600px)": {
                      fontSize: "0.75rem", // Make text smaller on mobile
                      padding: "4px 10px", // Adjust padding for smaller screens
                    },
                  }}
                >
                  Price: {`\u20B9`}{price}
                </Typography>


                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    color: "#fff",
                    background: "linear-gradient(45deg, #333333, #555555)",

                    borderRadius: "8px",
                    padding: "6px 12px",
                    textTransform: "uppercase",
                    mr: 1,
                    mt: 1,
                    letterSpacing: 2,
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
                    display: "inline-block",
                    fontSize: "0.875rem", // Smaller size for compactness
                    letterSpacing: "0.8px",
                    transition: "transform 0.3s ease-in-out, background 0.3s ease-in-out",
                    "&:hover": {
                      background: "linear-gradient(45deg, #6e7dff, #6b89ff)",
                      transform: "scale(1.05)",
                    },
                    "@media (max-width: 600px)": {
                      fontSize: "0.75rem", // Make text smaller on mobile
                      padding: "4px 10px", // Adjust padding for smaller screens
                    },
                  }}
                >
                  Date: {date ? new Date(date).toLocaleDateString('en-GB') : 'N/A'}
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    color: "#fff",
                    background: "linear-gradient(45deg, #333333, #555555)",

                    borderRadius: "8px",
                    padding: "6px 12px",
                    textTransform: "uppercase",
                    mr: 1,
                    mt: 1,
                    letterSpacing: 2,
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
                    display: "inline-block",
                    fontSize: "0.875rem", // Smaller size for compactness
                    letterSpacing: "0.8px",
                    transition: "transform 0.3s ease-in-out, background 0.3s ease-in-out",
                    "&:hover": {
                      background: "linear-gradient(45deg, #6e7dff, #6b89ff)",
                      transform: "scale(1.05)",
                    },
                    "@media (max-width: 600px)": {
                      fontSize: "0.75rem", // Make text smaller on mobile
                      padding: "4px 10px", // Adjust padding for smaller screens
                    },
                  }}
                >
                  Start Time: {formattedStartTime || "N/A"}
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    color: "#fff",
                    background: "linear-gradient(45deg, #333333, #555555)",

                    borderRadius: "8px",
                    padding: "6px 12px",
                    textTransform: "uppercase",
                    mr: 1,
                    letterSpacing: 2,
                    mt: 1,
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
                    display: "inline-block",
                    fontSize: "0.875rem", // Smaller size for compactness
                    letterSpacing: "0.8px",
                    transition: "transform 0.3s ease-in-out, background 0.3s ease-in-out",
                    "&:hover": {
                      background: "linear-gradient(45deg,  #6e7dff, #6b89ff)",
                      transform: "scale(1.05)",
                    },
                    "@media (max-width: 600px)": {
                      fontSize: "0.75rem", // Make text smaller on mobile
                      padding: "4px 10px", // Adjust padding for smaller screens
                    },
                  }}
                >
                  Duration: {durationFormatted}
                </Typography>



              </Grid>
              <Grid container spacing={2} justifyContent="center" alignItems="center" sx={{ mt: 0 }}>


                <Grid item xs={12} sm="auto" sx={{ textAlign: 'center' }}>
                  <Button
                    variant="contained"
                    color="info"
                    onClick={handleRedirect}
                    sx={{
                      letterSpacing: 4,
                      width: { xs: '100%', sm: 'auto' },  // Full width on small screens, auto on larger screens
                      padding: { xs: '0.75rem 1rem', sm: '0.875rem 1.5rem' },  // Adjust padding for different screen sizes
                      fontSize: { xs: '0.875rem', sm: '1rem' },  // Adjust font size for responsiveness
                      marginTop: { xs: '1rem', sm: '1.5rem' },  // Adjust margin top for spacing
                    }}
                  >
                    Session Instructions
                  </Button>
                </Grid>

                <Grid item xs={12} sm="auto" sx={{ textAlign: 'center' }}>
                  <a href="#" onClick={handleJoinClick} style={{ textDecoration: 'none' }}>
                    <Button
                      variant="contained"
                      color="primary"
                      sx={{
                        letterSpacing: 4,
                        width: { xs: '100%', sm: 'auto' },  // Full width on small screens, auto on larger screens
                        padding: { xs: '0.75rem 1rem', sm: '0.875rem 1.5rem' },  // Adjust padding for different screen sizes
                        fontSize: { xs: '0.875rem', sm: '1rem' },  // Adjust font size for responsiveness
                        marginTop: { xs: '1rem', sm: '1.5rem' },  // Adjust margin top for spacing
                      }}
                    >
                      Join Now
                    </Button>
                  </a>
                </Grid>

                <Grid item xs={12} sm="auto" sx={{ textAlign: 'center' }}>
                  <CancelSessionAcceptedRequestsButton requestId={id} userId={userId} />


                </Grid>




              </Grid>

              <Box sx={{ marginTop: '3rem' }}>
                <GenerateOTPButtonRequest requestId={id} userId={userId} />
              </Box>


              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                sx={{
                  letterSpacing: 3,
                  padding: { xs: '16px', sm: '24px', md: '32px' }, // responsive padding
                  textAlign: 'center',
                  width: '100%', // ensures box takes full width
                }}
              >
                {getLogo(meeting_platform) ? (
                  <img
                    src={getLogo(meeting_platform)}
                    alt={meeting_platform}
                    style={{
                      letterSpacing: 3,
                      width: '80px', // default width for small screens
                      height: 'auto', // preserve aspect ratio
                      maxWidth: '100px', // maximum width for larger screens
                    }}
                  />
                ) : (
                  <span style={{ fontStyle: 'italic', color: 'gray', letterSpacing: 3 }}>
                    Meeting Platform Info Not available
                  </span>
                )}

                <Typography
                  variant="body1"
                  sx={{
                    marginTop: '12px',
                    fontSize: { xs: '14px', sm: '16px', md: '18px' }, // responsive font size
                    fontWeight: 500,
                    color: '#333',
                    letterSpacing: 3
                  }}
                >
                  {getPlatformName(meeting_platform)} {/* Call getPlatformName() properly */}
                </Typography>
              </Box>



              <Box sx={{ textAlign: 'center', marginTop: '2rem', padding: '1rem', width: '100%' }}>



              </Box>
              <FeedbackFormAcceptedRequests userId={userId} requestId={id} />

            </Box>
          </Grid>
          <Grid container spacing={2} sx={{
            justifyContent: "center", marginTop: "5px", backgroundColor: '#000000', borderColor: '#5555',
            borderRadius: "15px",
            "&:hover": {
              borderColor: '#1E90FF',
            },
          }}>

          </Grid>
          <div>


            <Dialog
              open={openDialog}
              onClose={() => setOpenDialog(false)}
              PaperProps={{
                sx: {
                  backgroundColor: '#1e1e1e',
                  color: '#e0e0e0',
                  borderRadius: 2,
                  minWidth: { xs: '90%', sm: 600 },
                  maxHeight: '90vh',
                },
              }}
            >
              <DialogContent sx={{ pt: 3, pb: 1, px: 3 }}>
                <MeetingGuidelines />

                <Box sx={{ mt: 3 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                        sx={{
                          color: '#bb86fc',
                          '&.Mui-checked': {
                            color: '#bb86fc',
                          },
                        }}
                      />
                    }
                    label={
                      <Typography variant="body2" sx={{ color: '#e0e0e0', letterSpacing: 2 }}>
                        I acknowledge that I have read, understood, and agree to all the terms and conditions outlined above.
                      </Typography>
                    }
                  />
                </Box>
              </DialogContent>

              <DialogActions sx={{ px: 3, pb: 3 }}>
                <Button
                  onClick={() => setOpenDialog(false)}
                  variant="outlined"
                  color="secondary"
                  sx={{ letterSpacing: 3 }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleConfirmAndJoin}
                  variant="contained"
                  color="primary"
                  disabled={!isChecked}
                  sx={{
                    backgroundColor: !isChecked ? '#555' : '#1976d2',
                    letterSpacing: 3,
                    '&:hover': {
                      backgroundColor: !isChecked ? '#555' : '#1565c0',
                    },
                  }}
                >
                  Confirm and Join
                </Button>
              </DialogActions>
            </Dialog>


          </div>



        </Grid>


      </Box>
      <IconButton
        onClick={scrollToTop}
        sx={{ position: 'fixed', bottom: 16, right: 16, backgroundColor: 'white', color: 'black' }}>
        <ArrowUpwardIcon />
      </IconButton>
      <Footer2 />
    </div>
  );
};

export default AcceptedRequestTabDetails;